import { z } from 'zod'
import { oc } from '@orpc/contract'
import { actionTypeSchema, followUpStatusSchema } from './care-journeys.contract'

export const PATIENT_JOURNEY_STEP_KINDS = [
  'initial-appointment',
  'visit',
  'care-plan',
  'order',
  'result',
  'follow-up-appointment',
] as const
export const patientJourneyStepKindSchema = z.enum(PATIENT_JOURNEY_STEP_KINDS)

export const PATIENT_JOURNEY_STEP_STATES = ['done', 'current', 'upcoming', 'not-needed'] as const
export const patientJourneyStepStateSchema = z.enum(PATIENT_JOURNEY_STEP_STATES)

export const patientJourneyStepSchema = z.object({
  id: z.string(),
  visitId: z.string(),
  kind: patientJourneyStepKindSchema,
  state: patientJourneyStepStateSchema,
  at: z.string().nullable(),
  practitionerName: z.string().nullable(),
  summary: z.string().nullable(),
  performer: z.string().nullable(),
  actionType: actionTypeSchema.nullable(),
  orderId: z.string().nullable(),
  ready: z.boolean(),
  followUpStatus: followUpStatusSchema.nullable(),
})

export const patientCareJourney = oc
  .route({ method: 'GET', path: '/v2/patient/me/care-journey' })
  .input(z.object({}))
  .output(
    z.object({
      steps: z.array(patientJourneyStepSchema),
      truncated: z.boolean(),
    }),
  )
